import ContentElement from "./content-element.js";

import type {
    Timeline,
    TimelineItem,
    TimelineGroup,
    TimelineOptions,
    TimelineEvents
} from 'vis-timeline';

interface TimelineEntry {
    title: string;
    label?: string;
    indicator?: string;
    group?: string;
    teaser?: string;
    bodytext?: string;
    displaydate: string;
    startDate: string;
    endDate: string;
    renderedImages?: string[];
    renderedMedias?: string[];
}

interface TimelineSettings {
    dimension: string;
}

interface TimelineElementConfig {
    entries: TimelineEntry[],
    settings: TimelineSettings
}

const DEFAULT_ELEMENT_SELECTOR: string = '.th-fsc-timeline';

const defaultOptions: TimelineElementConfig = {
    entries: [],
    settings: {
        dimension: 'months'
    }
};


class TimelineElement extends ContentElement {
    protected options: TimelineElementConfig = defaultOptions;
    protected isLoaded: boolean = false;

    public override init() {
        this.options = this.assignConfig<TimelineElementConfig>(defaultOptions, this.config);
        let baseUrl = import.meta.url;
        baseUrl = baseUrl.substring(0, baseUrl.indexOf('/JavaScript'));

        if(document.querySelector('link#ckeditor') == null) {
            const linkEl = document.createElement('link');
            linkEl.setAttribute('rel', 'stylesheet');
            linkEl.setAttribute('href', baseUrl + '/Vendor/vis-timeline/vis-timeline-graph2d.min.css');
            linkEl.setAttribute('id', 'vis_timeline');
            document.querySelector('head')!.appendChild(linkEl);
        }
        import('../lib/vis-timeline.js').then((module) => {
            this.renderTimeline(module);
        });

    }

    private renderTimeline(vis) {
        const timeLineItems: TimelineItem[] = [];
        let minDate = new Date();
        let maxDate = new Date();
        this.options.entries.forEach((entry: TimelineEntry, idx: number) => {
            const startDate = new Date(entry.startDate);
            const item: TimelineItem = {
                id: 'entry_' + idx.toString(),
                title: entry.title,
                content: entry.title,
                start: startDate
            };
            if(startDate < minDate) {
                minDate = startDate;
            }
            if(startDate > maxDate) {
                maxDate = startDate;
            }
            if(entry.endDate !== '') {
                const endDate = new Date(entry.endDate);
                item.end = endDate;
                if(endDate > maxDate) {
                    maxDate = endDate;
                }
            }
            timeLineItems.push(item);
        });

        const options: TimelineOptions = {
            min: minDate,
            max: maxDate,
            autoResize: true,
        };

        const timeline: Timeline = new vis.Timeline(this.element, timeLineItems, options);
        timeline.on('click', (ev: TimelineEvents ) => {
            console.log(ev);
        });
    }
}

// Observe
TimelineElement.initializeDom(DEFAULT_ELEMENT_SELECTOR, true, false, true);

export type { TimelineElementConfig };
export default TimelineElement;
